<template>
  <div class="collection-page">
    <div class="collection-page-container">
      <div class="row header">
        <div class="row header-left">
          <div @click="toCollectionList" class="my-collection">我的收藏</div>
          <!-- <div @click="showCollectionList = true" class="my-collection">我的收藏</div> -->
          <img v-if="!showCollectionList" src="../assets/img/right-arrow.svg" alt="">
          <div v-if="!showCollectionList">{{folderName}}</div>
        </div>
        <div class="header-right">
          <!-- <div v-if="showCollectionList" @click="showAddFolderInput = true" class="add-folder"> -->
          <div v-if="showCollectionList" @click="onAddFolderClick" class="add-folder">
            <div class="add-folder-img"></div>
          </div>
        </div>
      </div>
      <div v-if="showCollectionList" class="collection-list">
        <div @mouseover="mouseoverFolder(index)" @mouseleave="mouseleaveFolder" @click="onShowCollectionList(item)" class="row collection-list-item" v-for="(item, index) in folderNames" :key="index">
          <div v-if="editIndex != index" class="collection-list-item-left">
            {{item.name}}
          </div>
          <div v-if="editIndex != index" class="row collection-list-item-right">
            <div v-if="mouseoverFolderIndex === index && item.name !== '默认收藏夹'" class="edit-img" @click.stop="onEditFolderName(index, item.name)"></div>
            <div v-if="mouseoverFolderIndex === index && item.name !== '默认收藏夹'" @click.stop="onDelFolder(item.name)" class="delete-img"></div>
            <div class="count">{{item.count}}条内容</div>
          </div>
          <input @blur="editIndex = -1" @click.stop v-if="editIndex === index" type="text" class="edit-folder-input" v-model.trim="editFolderInput" @keypress.enter="onEditFolderConfirm()"/>
          <div v-if="editIndex === index" class="edit-folder-input-count">{{item.count}}条内容</div>
        </div>
        <div>
          <input ref="input" @blur="showAddFolderInput = false" v-if="showAddFolderInput" type="text" class="add-folder-input" v-model.trim="newFolderInput" @keypress.enter="onAddFolder()" />
        </div>
      </div>
      <div class="filter" v-if="!showCollectionList">
        <div v-if="totalCount" class="row filter-content">
          <div class="filter-content-left">
            <el-checkbox class="check-all" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选本页</el-checkbox>
            <span class="news-count" v-if="!this.checkedId.length">共<span class="count">{{totalCount}}</span>条相关新闻</span>
            <el-button v-if="this.checkedId.length" class="batch-btn" @click="batchDownloadTextBtnClick">下载</el-button>
          </div>
          <div class="filter-content-right">
            <el-button v-if="showDetails" class="show-hidden-details" @click="onShowHiddenDetails">全部隐藏详情</el-button>
            <el-button v-else class="show-hidden-details" @click="onShowHiddenDetails">全部显示详情</el-button>
            <el-select v-model="option" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div>
          <div v-for="(item, index) in collectionData" :key="index">
            <div v-if="item.category==='pdf'">
              <research-report-text-list-item @noDownloadPermissions="noDownloadPermissions" @changeDetailStatus="changeDetailStatus" @uncollect="uncollectPdf" :showDel="true" :data="item" @download="download" @change="changeChecked"></research-report-text-list-item>
            </div>
            <div v-if="item.category==='figure'">
              <research-report-chart-list-item @noDownloadPermissions="noDownloadPermissions" @uncollect="uncollectChart" :showDel="true" :data="item" @download="download" @change="changeChecked"></research-report-chart-list-item>
            </div>
          </div>
        </div>

        <div class="row footer" v-if="!showCollectionList && totalCount">
          <div class="pager">
            <el-pagination
              class="left-bottom-pagination border-pagination"
              @current-change="handleCurrentChange"
              :current-page.sync="pageNum"
              :page-size="pageSize"
              layout="prev, pager, next"
              :total="totalCount"
            ></el-pagination>
          </div>
          <!-- <div>
            <el-select v-model="pageOption" placeholder="请选择">
              <el-option
                v-for="item in pageOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div> -->
          <div class="page-size-selector row">
            <el-dropdown @command="handlePageSizeChange" class="page-size-dropdown">
              <span class="el-dropdown-link">
                {{pageSize}}条/页<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(size, index) in [20,50,100]" :key="index" :command="size">{{size}}条/页</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="删除收藏"
      class="del-collect-dialog"
      :visible.sync="delCollectDialogVisible"
      width="410px"
      >
      <div class="dialog-content">
        确认将此内容从收藏夹中删除
      </div>
      <span slot="footer" class="row dialog-footer">
        <div></div>
        <div>
          <el-button class="btn cancel-btn" @click="onUncollectDialogCancel">取消</el-button>
          <el-button class="btn confirm-btn" @click="onUncollectDialogConfirm">删除</el-button>
        </div>
      </span>
    </el-dialog>

    <el-dialog
      title="删除收藏夹"
      class="del-collect-dialog"
      :visible.sync="delCollectFolderDialogVisible"
      width="410px"
      >
      <div class="dialog-content">
        删除收藏夹后，收藏的内容也将消失！！！
      </div>
      <span slot="footer" class="row dialog-footer">
        <div></div>
        <div>
          <el-button class="btn cancel-btn" @click="onDelFolderDialogCancel">取消</el-button>
          <el-button class="btn confirm-btn" @click="onDelFolderDialogConfirm">删除</el-button>
        </div>
      </span>
    </el-dialog>

    <el-dialog
      title=""
      class="members-expired-dialog"
      :visible.sync="membersExpiredDialogVisible"
      width="380px"
      :show-close=false
    >
      <div class="members-expired-dialog-content">
        <img src="../assets/img/members-expired.svg" alt="">
        <div class="members-expired-prompt">您的会员已到期,请续费</div>
        <div class="members-expired-date">会员到期时间: {{userInfo}}</div>
        <el-button @click="onRenewalBtnClick" class="renewal-btn">立即续费</el-button>
        <el-button @click="onIgnoreBtnClick" class="ignore-btn">忽略</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QuestionQuery from '@/rest/questionQuery';
import ResearchReportChartListItem from '@/components/research-report/ResearchReportChartListItem';
import ResearchReportTextListItem from '@/components/research-report/ResearchReportTextListItem';

export default {
  data() {
    return {
      userInfo: '',
      membersExpiredDialogVisible: false,
      originalFolderName: '',
      deleteFolderName: '',
      mouseoverFolderIndex: -1,
      editIndex: -1,
      editFolderInput: '',
      delCollectFolderDialogVisible: false,
      newFolderInput: '',
      showAddFolderInput: false,
      showDetails: false,
      uncollectId: 0,
      uncollectType: 'text',
      delCollectDialogVisible: false,
      pageNum: 1,
      pageSize: 20,
      folderNames: [],
      folderName: '',
      showCollectionList: true,
      collectionData: [],
      isIndeterminate: false,
      checkAll: false,
      checkedId: [],
      totalCount: 0,
      options: [
        {
          value: 'ASC',
          label: '时间最早'
        },
        {
          value: 'DESC',
          label: '时间最近'
        }
      ],
      option: 'DESC'
    };
  },
  methods: {
    onAddFolderClick() {
      this.showAddFolderInput = true;
      this.newFolderInput = '';
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    },
    onRenewalBtnClick() {
      this.$router.push('/recharge');
    },
    onIgnoreBtnClick() {
      this.membersExpiredDialogVisible = false;
    },
    noDownloadPermissions() {
      this.membersExpiredDialogVisible = true;
    },
    toCollectionList() {
      this.showCollectionList = true;
      this.getFolderNames();
    },
    mouseoverFolder(index) {
      this.mouseoverFolderIndex = index;
    },
    mouseleaveFolder() {
      this.mouseoverFolderIndex = -1;
    },
    onEditFolderConfirm() {
      if (!this.editFolderInput) {
        this.$message({
          message: '文件夹名称不能为空',
          duration: 1000,
          type: 'error'
        });
      } else if (this.folderNames.some(item => item.name === this.editFolderInput)) {
        this.$message({
          message: '文件夹名称重复',
          duration: 1000,
          type: 'error'
        });
      } else {
        QuestionQuery.changeFolderName(this.originalFolderName, this.editFolderInput).then(() => {
          this.editIndex = -1;
          this.getFolderNames();
        });
      }
    },
    onDelFolderDialogCancel() {
      this.delCollectFolderDialogVisible = false;
    },
    onDelFolderDialogConfirm() {
      QuestionQuery.deleteFolder(this.deleteFolderName).then(() => {
        this.delCollectFolderDialogVisible = false;
        this.getFolderNames();
      });
    },
    onEditFolderName(index, name) {
      this.editIndex = index;
      this.originalFolderName = name;
      this.editFolderInput = name;
    },
    onDelFolder(name) {
      this.deleteFolderName = name;
      this.delCollectFolderDialogVisible = true;
    },
    onAddFolder() {
      if (!this.newFolderInput) {
        this.$message({
          message: '文件夹名称不能为空',
          duration: 1000,
          type: 'error'
        });
      } else if (this.folderNames.some(item => item.name === this.newFolderInput)) {
        this.$message({
          message: '文件夹名称重复',
          duration: 1000,
          type: 'error'
        });
      } else {
        QuestionQuery.addFolder(this.newFolderInput).then(() => {
          this.showAddFolderInput = false;
          this.newFolderInput = '';
          this.getFolderNames();
        });
      }
    },
    onShowHiddenDetails() {
      if (this.collectionData.every(item => item.showSummary)) {
        this.collectionData.forEach(item => {
          item.showSummary = false;
        });
        this.showDetails = false;
      } else if (this.collectionData.some(item => item.showSummary)) {
        this.collectionData.forEach(item => {
          item.showSummary = true;
        });
        this.showDetails = true;
      } else {
        this.collectionData.forEach(item => {
          item.showSummary = true;
        });
        this.showDetails = true;
      }
    },
    changeDetailStatus(id) {
      this.collectionData.forEach(item => {
        if (item.id === id) {
          item.showSummary = !item.showSummary;
        }
      });
      if (this.collectionData.every(item => item.showSummary)) {
        this.showDetails = true;
      } else if (this.collectionData.some(item => item.showSummary)) {
        this.showDetails = false;
      } else {
        this.showDetails = false;
      }
    },
    onUncollectDialogConfirm() {
      if (this.uncollectType === 'text') {
        QuestionQuery.uncollectPdf(this.uncollectId).then(() => {
          this.delCollectDialogVisible = false;
          this.getDisplayCollectionList();
        });
      } else if (this.uncollectType === 'chart') {
        QuestionQuery.uncollectFigure(this.uncollectId).then(() => {
          this.delCollectDialogVisible = false;
          this.getDisplayCollectionList();
        }); 
      }
    },
    onUncollectDialogCancel() {
      this.delCollectDialogVisible = false;
    },
    uncollectChart(id) {
      this.uncollectId = [id];
      this.uncollectType = 'chart';
      this.delCollectDialogVisible = true;
    },
    uncollectPdf(id) {
      this.uncollectId = [id];
      this.uncollectType = 'text';
      this.delCollectDialogVisible = true;
    },
    handleCurrentChange(page) {
      this.pageNum = page; 
      this.getDisplayCollectionList();
    },
    batchDownloadTextBtnClick() {
      const id = this.checkedId.map(item => {
        return item.id;
      });
      this.batchDownloadQuestionQuery(id);
    },
    handleCheckAllChange() {
      if (this.collectionData.every(item => item.checked)) {
        this.collectionData.forEach(item => {
          item.checked = false;
        });
      } else if (this.collectionData.some(item => item.checked)) {
        this.collectionData.forEach(item => {
          item.checked = true;
        });
      } else {
        this.collectionData.forEach(item => {
          item.checked = true;
        });
      }
      this.changeChecked();
    },
    changeChecked() {
      if (this.collectionData.every(item => item.checked)) {
        this.checkAll = true;
        this.isIndeterminate = false;
        this.checkedId = [];
        this.checkedId = this.collectionData.map(item => {
          return {
            id: item.id,
            text: item.itxt
          };
        });
      } else if (this.collectionData.some(item => item.checked)) {
        this.checkedId = [];
        this.checkAll = false;
        this.isIndeterminate = true;
        this.collectionData.forEach(item => {
          if (item.checked) {
            this.checkedId.push(item);
          }
        });
      } else {
        this.checkedId = [];
        this.checkAll = false;
        this.isIndeterminate = false;
      }
    },
    download(id) {
      this.batchDownloadQuestionQuery([id]);
    },
    batchDownloadQuestionQuery(id) {
      QuestionQuery.batchDownload(id).then(res => {
        const url = window.URL.createObjectURL(new Blob([res]), {
          type: 'application/octet-stream'
        });
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', 'file.zip');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      () => {
        this.membersExpiredDialogVisible = true;
      });
    },
    onShowCollectionList(res) {
      this.collectionData = [];
      this.totalCount = 0;
      this.folderName = res.name;
      this.showCollectionList = false;
      this.getDisplayCollectionList();
    },
    getDisplayCollectionList() {
      // this.collectionData = [];
      QuestionQuery.getDisplayCollectionList(this.folderName, this.pageNum, this.pageSize, this.option).then(result => {
        result.pageItems.forEach((item, index) => {
          if (!index) {
            item.showSummary = true;
          } else if (index) {
            item.showSummary = false;
          }
          item.checked = false;
        });
        result.pageItems.forEach(item => {
          item.keywords = item.highlight.text;
        });
        this.collectionData = result.pageItems;
        this.totalCount = result.totalCount;
      });
    },
    getFolderNames() {
      QuestionQuery.getDisplay().then(res => {
        this.folderNames = res.folderNames;
      });
    },
    handlePageSizeChange(size) {
      this.pageSize = Number(size);
      this.pageNum = 1;
      this.getDisplayCollectionList();
    },
    getUserInfo() {
      QuestionQuery.getUserInfo().then(res => {
        this.userInfo = res.expire_at;
      });
    }
  },
  watch: {
    option() {
      this.pageNum = 1;
      this.getDisplayCollectionList();
    }
  },
  components: {
    ResearchReportChartListItem,
    ResearchReportTextListItem
  },
  mounted() {
    this.getFolderNames();
    this.getUserInfo();
    eventBus.$on('isVistor', () => {
      this.membersExpiredDialogVisible = true;
    });
  }
};
</script>

<style lang="scss" scoped>
  .collection-page {
    padding: 24px 0;
    background-color: #f7f7fa;
    .collection-page-container {    
      width: 1200px;
      min-height: calc(100vh - 116px);
      margin: 0 auto;
      background-color: #ffffff;
      .header {
        position: relative;
        justify-content: space-between;
        padding: 13px 32px;
        width: 100%;
        height: 48px;
        font-size: 14px;
        box-shadow: inset 0px -1px 0px 0px#f2f3f7;
        .header-left {
          width: 800px;
          // margin-top: 5px;
          .my-collection {
            color: #747990;
            cursor: pointer;
          }
        }
        .header-right {
          .add-folder {
            position: absolute;
            top: 8px;
            right: 32px;
            width: 48px;
            height: 32px;
            border-radius:2px;
            border:1px solid rgba(229,230,238,1);
            background:rgba(255,255,255,1);
            cursor: pointer;
            .add-folder-img {
              margin-left: 16px;
              margin-top: 8px;
              width: 16px;
              height: 16px;
              line-height: 16px;
              background: url("../assets/img/add-folder.svg") no-repeat;
              background-size: cover;
              cursor: pointer;
              &:hover {
                background: url("../assets/img/add-folder-hover.svg") no-repeat;
              }
            }
          }
        }
      }
      .collection-list {
        padding: 16px 32px;
        .collection-list-item {
          position: relative;
          justify-content: space-between;
          padding: 12px 16px;
          margin-bottom: 10px;
          width: 100%;
          height: 48px;
          color: #171f46;
          font-weight: 500;
          font-size: 16px;
          background-color: rgba(0, 11, 92, 0.03);
          cursor: pointer;
          &:hover {
            background-color: rgba(0, 11, 92, 0.06);
          }
          .collection-list-item-right {
            font-size: 12px;
            font-weight: 500;
            color: #747990;
            .edit-img {
              margin-top: 4px;
              width: 14px;
              height: 14px;
              line-height: 16px;
              background: url("../assets/img/edit.svg") no-repeat;
              background-size: cover;
              cursor: pointer;
              &:hover {
                background: url("../assets/img/edit-hover.svg") no-repeat;
              }
            }
            .delete-img {
              margin: 4px 24px 0 17px;
              width: 14px;
              height: 14px;
              line-height: 16px;
              background: url("../assets/img/delete.svg") no-repeat;
              background-size: cover;
              cursor: pointer;
              &:hover {
                background: url("../assets/img/delete-hover.svg") no-repeat;
              }
            }
            .count {
              margin-top: 3px;
            }
          }
        }
        .edit-folder-input-count {
          position: absolute;
          right: 12px;
          top: 16px;
          font-size: 12px;
          font-weight: 500;
          color: #747990;
        }
        .edit-folder-input {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 48px;
          padding-left: 16px;
          border-radius: 2px;
          border: solid 2px #171f46;
          font-weight: 500;
          font-size: 16px;
          color: #171f46;
          outline: none;
          &:hover {
            border: solid 2px #999ebe;
          }
          &:focus {
            border: solid 2px #171f46;
          }
        }
        .add-folder-input {
          width: 100%;
          height: 48px;
          padding-left: 16px;
          border-radius: 2px;
          border: solid 2px #171f46;
          font-weight: 500;
          font-size: 16px;
          color: #171f46;
          outline: none;
          &:hover {
            border: solid 2px #999ebe;
          }
          &:focus {
            border: solid 2px #171f46;
          }
        }
      }
      .filter {
        padding: 16px 32px 0;
        .filter-content {
          justify-content: space-between;
          height: 48px;
          line-height: 48px;
          box-shadow: inset 0px -1px 0px 0px#f2f3f7;
          .check-all {
            margin-right: 16px;
          }
          .news-count {
            color: #747990;
            font-size: 14px;
            .count {
              color: #171f46;
              font-size: 14px;
            }
          }
          .batch-btn {
            height: 32px;
            width: 60px;
            padding: 0;
            font-size: 14px;
            color: #171f46;
            border-radius: 2px;
            font-weight: 400;
            border: 1px solid #e5e6ee;
            &:hover {
              border: 1px solid #171f46;
              color: #171f46;
              background-color: #ffffff;
            }
            &:focus {
              border: 1px solid #171f46;
              color: #171f46;
              background-color: #ffffff;
            }
            &:active {
              border: 1px solid #171f46;
              color: #171f46;
              background-color: #f2f3f7;
            }
          }
          .batch-btn:last-child {
            margin-left: 16px;
          }
          .show-hidden-details {
            height: 32px;
            width: 116px;
            padding: 0;
            font-size: 14px;
            color: #171f46;
            border-radius: 2px;
            font-weight: 400;
            border: 1px solid #e5e6ee;
            &:hover {
              border: 1px solid #171f46;
              color: #171f46;
              background-color: #ffffff;
            }
            &:focus {
              border: 1px solid #171f46;
              color: #171f46;
              background-color: #ffffff;
            }
            &:active {
              border: 1px solid #171f46;
              color: #171f46;
              background-color: #f2f3f7;
            }
          }
        }
      }
    }
  }
.footer {
  padding: 16px 0 16px;
  justify-content: space-between;
  .page-size-selector {
    align-items: center;
    border: 1px solid #e5e6ee;
    border-radius: 2px;
    padding: 3px 12px;
    font-size: 12px;
  }
}
.el-select {
  margin-left: 10px;
  width: 108px;
}
  /deep/.el-select .el-input__inner {
    height: 32px;
    border: 1px solid #e5e6ee;
    border-radius: 2px;
    color: #171f46;
  }
  /deep/.el-select .el-input .el-select__caret {
    color: #171f46;
  }
  /deep/.del-collect-dialog {
    .dialog-input {
      width: 352px;
      height: 40px;
      padding-left: 16px;
      border-radius: 2px;
      border: solid 1px #e5e6ee;
      color: #171f46;
      outline: none;
      &:hover {
        border: solid 1px #999ebe;
      }

      &:focus {
        border: solid 1px #171f46;
      }
    }
    .el-dialog {
      box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
      border-radius: 2px;
      border: solid 1px #f7f7fa;
      .el-dialog__header {
        padding: 24px 24px 14px;
        .el-dialog__title {
          font-size: 16px;
        }
      }
      .el-dialog__body {
        max-height: 300px;
        overflow: auto;
        padding: 9px 24px 63px;
      }
      .el-dialog__footer {
        padding: 0 24px 24px;
      }
    }
}
.dialog-content {
  font-size: 14px;
  color: #747990;
}
.dialog-footer {
  justify-content: space-between;
  .cancel-btn {
    width: 60px;
    color: #171f46;
    background-color: rgba(0, 11, 92, 0.03);
    &:hover {
      color: #171f46;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
      background-blend-mode: normal, normal;
    }
    &:focus {
      color: #171f46;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
      background-blend-mode: normal, normal;
    }
    &:active {
      color: #171f46;
      background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
    background-blend-mode: normal, normal;
    }
  }
  .btn {
    height: 32px;
    padding: 0;
    border-radius: 2px;
    border: none;
    font-size: 14px;
  }
  .confirm-btn {
    width: 60px;
    color: #ffffff;
    background-color: #0055ff;
    &:hover {
      color: #ffffff;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(#0055ff, #0055ff);
      background-blend-mode: normal, normal;
    }
    &:focus {
      color: #ffffff;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(#0055ff, #0055ff);
      background-blend-mode: normal, normal;
    }
    &:active {
      color: #ffffff;
      background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(#0055ff, #0055ff);
      background-blend-mode: normal, normal;
    }
  }
}

/deep/.members-expired-dialog {
  .members-expired-dialog-content {
    height: 100%;
    width: 100%;
    position: relative;
    padding: 44px 0 28px 88px;
    .members-expired-prompt {
      margin: 12px 0 12px 3px;
      color: #171717;
      font-size: 18px;
      font-weight: 500;
    }
    .members-expired-date {
      margin-left: 16px;
      color: #666666;
      font-size: 12px;
    }
    .renewal-btn {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 78px;
      height: 40px;
      width: 132px;
      padding: 0;
      border-radius: 2px;
      border: none;
      font-size: 14px;
      font-weight: 500;
      color: #ffffff;
      background-color: #0055ff;
      &:hover {
        color: #ffffff;
        background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(#0055ff, #0055ff);
        background-blend-mode: normal, normal;
      }
      &:focus {
        color: #ffffff;
        background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(#0055ff, #0055ff);
        background-blend-mode: normal, normal;
      }
      &:active {
        color: #ffffff;
        background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(#0055ff, #0055ff);
        background-blend-mode: normal, normal;
      }
    }
    .ignore-btn {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 28px;
      margin-left: 0;
      height: 40px;
      width: 132px;
      padding: 0;
      border-radius: 2px;
      border: none;
      font-size: 14px;
      color: #666666;
      background-color: rgba(0, 11, 92, 0.03);
      &:hover {
        color: #666666;
        background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
        background-blend-mode: normal, normal;
      }
      &:focus {
        color: #666666;
        background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
        background-blend-mode: normal, normal;
      }
      &:active {
        color: #666666;
        background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
        background-blend-mode: normal, normal;
    }
  }
  }
  .el-dialog {
    box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
    border-radius: 2px;
    border: solid 1px #f7f7fa;
    .el-dialog__header {
      padding: 0;
      .el-dialog__title {
        font-size: 16px;
      }
    }
    .el-dialog__body {
      height: 470px;
      padding: 0;
    }
    .el-dialog__footer {
      padding: 0;
    }
  }
}
</style>
